export default __webpack_public_path__ + "static/media/Eclipse.1a120c53.gif";